import Vue from 'vue'
import VirtualList from 'vue-virtual-scroll-list'

Vue.component('virtual-list', VirtualList)
